import { formatUnits } from "viem";

/** Truncate, never round up — finance display rule of thumb. */
export const truncate = (n: number, places: number): number => {
  const factor = 10 ** places;
  return Math.trunc(n * factor) / factor;
};

export const formatNumber = (
  n: number,
  fractionDigits = 2,
): string =>
  truncate(n, fractionDigits).toLocaleString("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

export const formatUsd = (n: number, fractionDigits = 2): string =>
  `$${formatNumber(n, fractionDigits)}`;

export const formatToken = (
  raw: bigint,
  decimals: number,
  fractionDigits = 4,
): string => formatNumber(Number(formatUnits(raw, decimals)), fractionDigits);

export const formatPercent = (ratio: number, fractionDigits = 1): string =>
  `${formatNumber(ratio * 100, fractionDigits)}%`;

export const formatBps = (bps: number): string =>
  `${formatNumber(bps / 100, 2)}%`;

/** 0xabcd…ef01 — for header chip. */
export const formatAddress = (addr: string): string =>
  addr.length <= 10 ? addr : `${addr.slice(0, 6)}…${addr.slice(-4)}`;
